module.exports = {
	"root": "findify-layouts--tabs",
	"item": "findify-layouts--tabs__item",
	"active": "findify-layouts--tabs__active",
	"count": "findify-layouts--tabs__count"
};